import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Row, Col } from "react-bootstrap";

export function WarningLTV({ name, warning}) {
    return (
        <div
            style={{
                display: "flex",
                flexWrap: "nowrap",
                justifyContent: "start",
                alignItems: "center",
                gap: 0,
                paddingTop: '10px'
            }}
        >
            <div
                style={{
                    margin: 0,
                    width: "23px",
                    display: "flex",
                    flexWrap: "nowrap",
                    justifyContent: "center",
                    alignItems: "flex-end",
                }}
            >
                <ExclamationTriangleIcon
                    style={{
                        color: "#DE5459",
                        height: "25px",
                        width: "23px",
                        fontWeight: "400",
                    }} />
            </div>
            <div style={{ paddingInlineStart: "6px" }}></div>
            <div
                style={{
                    margin: 0,
                    width: "489px",
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "flex-start",
                }}
            >
                <p
                    style={{
                        margin: 0,
                        color: "#898C93",
                        margin: 0,
                        fontFamily: "inter",
                        fontSize: "14px",
                        fontWeight: "700",
                    }}
                >
                    {name + ":"}
                </p>
                <p
                    style={{
                        margin: 0,
                        color: "#898C93",
                        fontFamily: "inter",
                        fontSize: "14px",
                        fontWeight: "400",
                        paddingInlineStart: "3px"
                    }}
                >{warning} 
                </p>
            </div>
        </div>
    );
}
